<template>
  <div class="Reports__View">
    <EntityListLayout v-if="tabs.length" :tabs="tabs" ref="entity" @onNewEntitySave="onNewEntitySave">
      <template #title>ניהול אזורים בקורס {{ course.name }}</template>
      <template #button>
        <a @click="addLecturesRegion" class="link-button">
          הוספת אזור
        </a>
      </template>
      <template v-slot:counter="slotProps">
        סה"כ <b>{{ getTotalRecords(slotProps) }} </b>
      </template>
    </EntityListLayout>
  </div>
</template>
<script>
import CoursesService from "@/services/CoursesService";
import EntityListLayout from "@/components/EntityListLayout.vue";
import LecturesRegionEntity from "@/views/LecturesRegionEntity.vue";
import DialogAddLecturesRegion from '@/components/DialogAddLecturesRegion.vue';
import {
  ModalProgrammatic as Modal,
} from 'buefy';
import FieldService from "@/services/FieldService";

export default {
  name: "Reports",
  data() {
    return {
      tabs: [],
    };
  },
  components: {
    EntityListLayout,
  },
  created() {
    this.create();
  },
  computed: {
    course() {
      return this.$store.state.auth?.course;
    },
  },
  methods: {
    create() {
      const lessonsFields = FieldService.list("lecturesRegions");
      // const reportsfilters = FilterService.list();

      const sideViewEntity = {
        component: LecturesRegionEntity,
        preview: true,
        readOnly: !this.isAdmin,
        title: "פרטי אזור",
        recordUrl: "books",
        recordTitle: "הצג ספר",
        hideRecord: true
      };
      const fields = [
        { ...lessonsFields.Id, checked: true },
        { ...lessonsFields.Name, checked: true },
        { ...lessonsFields.Description, checked: true },
        { ...lessonsFields.Status, checked: true },
        { ...lessonsFields.SortOrder, checked: true },
      ];

      this.tabs = [
        {
          id: "AllLecturesRegions",
          isPrimary: true,
          title: "כל האזורים",
          getDataAsync: this.getAllRegions,
          perPage: 100,
          fields,
          filters: null,
          sortField: "Id",
          sortOrder: "desc",
          checkableRows: false,
          fastSearch: true,
          fastSearchOptions: {
            propName: "Terms",
            label: "חיפוש מהיר",
          },
          sideViewEntity,
        },
      ];
    },
    addLecturesRegion() {
      Modal.open({
        component: DialogAddLecturesRegion,
        props: {
          store: this.$store
        },
        canCancel: false,
        hasModalCard: true,
        trapFocus: true,
      });
    },
    onNewEntitySave() {
      this.$refs.entity.onNewEntityCancel();
    },
    getAllRegions({ ...rest }) {
      return CoursesService.getCourseRegions(this.course.id, rest).then((r) => ({
        data: {
          TotalResults: r.data.totalResults,
          Items: r.data.items,
        },
      }));
    },
    getTotalRecords(slotProps) {
      return slotProps.tab && slotProps.tab.total && slotProps.tab.total;
    },
  },
};
</script>
<style scoped lang="scss">
.link-button {
  background: #00427e;
  border: none;
  border-radius: 3px;
  padding: 14px 25px;
  color: white;
  cursor: pointer;
}
</style>
